import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('API_URL');
export const PLATFORM_API_URL = new InjectionToken<string>('PLATFORM_API_URL');

// UI
export const GLOBAL_TOAST_KEY = 'global-toast';
export const GLOBAL_CONFIRMATION_KEY = 'global-confirmation';
